import React, { useRef, useState } from 'react';
import Button from '../buttons/Button';

const SpreadsheetUploadInput = ({
  label = 'Escolher arquivo...',
  buttonText = 'ADICIONAR',
  name = 'spreadsheet',
  onFileSelect,
  required = false,
  disabled = false,
}) => {
  const fileInputRef = useRef();
  const [fileName, setFileName] = useState('');

  const handleButtonClick = () => {
    if (!disabled) fileInputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      if (onFileSelect) onFileSelect(file);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div
        className={`flex-1 border border-bluePale rounded-xl px-3 py-3 text-base text-blueDarker bg-white cursor-pointer truncate ${
          disabled && 'opacity-50 cursor-not-allowed'
        }`}
        onClick={handleButtonClick}
        title={fileName || label}
      >
        {fileName || label}
      </div>

      <input
        type="file"
        ref={fileInputRef}
        name={name}
        onChange={handleChange}
        accept=".xls,.xlsx,.csv"
        required={required}
        disabled={disabled}
        className="hidden"
      />

      <Button disabled={disabled} type="button" onClick={handleButtonClick}>
        {buttonText}
      </Button>
    </div>
  );
};

export default SpreadsheetUploadInput;
